module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.13/_next/static/images/post-golpes-lno-2a934e2ff5006a610c9535cdb8d0edc9.webp";